import React from 'react';
import { useFormContext } from 'react-hook-form';
import Typography from '@material-ui/core/Typography';
import { RHFInputText } from '../../packages/react-hook-form';
import { MaskedSwedishSsnInput } from '../input/components';
import { MaskedSwedishPostNumberInput } from '../input/components/masked-swedish-postnumber-input';
import { RHFAutocompleteMultiField } from '../../packages/react-hook-form/autocomplete-multi-field/rhf-autocomplete-multifield';
import { Person } from '../../global/entities/Person';
import { emptyPersonObject } from '../buy-process-form/components/representatives/representatives-utils';
import { SWEDISH_SSN_PLACEHOLDER } from '../../global/constants';
import styles from './styles.module.scss';

interface PersonInputProps {
  nameAugmentFunction?: (name: string) => string;
  fieldName: string;
  people: Person[];
}

export const PersonInput = ({
  nameAugmentFunction = (n) => n,
  fieldName,
  people,
}: PersonInputProps) => {
  const { errors, control, setValue } = useFormContext();

  const setValueOptions = {
    shouldDirty: true,
    shouldValidate: true,
  };

  const handleAutocompleteField = (person: Person) => {
    setValue(fieldName, person, setValueOptions);
  };

  const handleAutocompletePrimitive = (value: string) => {
    setValue(nameAugmentFunction('firstName'), value, setValueOptions);
  };

  return (
    <div className={styles.groupLayout}>
      <RHFAutocompleteMultiField
        handleAutocompleteField={handleAutocompleteField}
        handleAutocompletePrimitive={handleAutocompletePrimitive}
        handleClearFields={() => setValue(fieldName, emptyPersonObject)}
        options={people}
        name={nameAugmentFunction('firstName')}
        required
        label="Samtliga förnamn"
        control={control}
        errors={errors}
        getOptionLabel={(option) => option.firstName}
        fullWidth
        freeSolo
        renderOption={(option) => (
          <Typography variant="caption">
            {option.firstName} {option.lastName} ({option.socialSecurityNumber})
          </Typography>
        )}
      />

      <RHFInputText
        label="Efternamn"
        errors={errors}
        name={nameAugmentFunction('lastName')}
        control={control}
        required
      />

      <RHFInputText
        placeholder={SWEDISH_SSN_PLACEHOLDER}
        control={control}
        errors={errors}
        name={nameAugmentFunction('socialSecurityNumber')}
        required
        InputProps={{ inputComponent: MaskedSwedishSsnInput }}
        label="Personnummer"
      />

      <RHFInputText
        control={control}
        errors={errors}
        name={nameAugmentFunction('postalCode')}
        required
        label="Postnummer"
        InputProps={{ inputComponent: MaskedSwedishPostNumberInput }}
      />

      <RHFInputText
        errors={errors}
        name={nameAugmentFunction('city')}
        control={control}
        required
        label="Ort"
      />

      <RHFInputText
        errors={errors}
        name={nameAugmentFunction('address')}
        control={control}
        required
        label="Utdelningsadress"
      />
    </div>
  );
};
